import { useState } from "react"
import { CaretDown } from "@phosphor-icons/react"
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible"
import { cn } from "@/lib/utils"
import { DateEntry, UsernameEntry, YearEntry } from "@/modules/patients/history/libs/transform-audit-events-to-timeline"
import { TimelineItem } from "@/modules/patients/history/timeline-item"

type CollapsibleWithIconProps = { dateGroup: DateEntry; firstEntry: UsernameEntry }

const CollapsibleWithIcon = ({ dateGroup, firstEntry }: CollapsibleWithIconProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen} key={dateGroup.date}>
      <CollapsibleTrigger className={cn("flex w-full", { "mb-0": isOpen })} asChild>
        <div className="flex w-full cursor-pointer">
          <CaretDown className={cn("mr-2 h-4 w-4 transition-transform", { "rotate-180": isOpen })} />
          {isOpen ? (
            <div className="group flex gap-4">
              <p className="text-on-surface w-20 shrink-0 font-medium">{dateGroup.date}</p>
            </div>
          ) : (
            <TimelineItem
              key={firstEntry.username}
              date={dateGroup.date}
              username={firstEntry.username}
              time={firstEntry.content[0].time}
              action={firstEntry.content[0].action}
              className="rounded-t-full rounded-b-full group-only:h-[calc(100%-4px)]"
              isFirstOne
            />
          )}
        </div>
      </CollapsibleTrigger>
      <CollapsibleContent className={cn("pl-6", { "-mt-7": isOpen })}>
        {dateGroup.content.map((actionGroup, itemIdx) => {
          const key = actionGroup.username + itemIdx
          return (
            <li key={key} className="mt-2">
              {actionGroup.content.map((timeline, timelineIndex) => {
                const key = timeline.time + timelineIndex
                const isFirstOne = timelineIndex === 0
                return (
                  <TimelineItem
                    key={key}
                    username={actionGroup.username}
                    time={timeline.time}
                    action={timeline.action}
                    isFirstOne={isFirstOne}
                    onClick={isFirstOne && isOpen ? () => setIsOpen(false) : undefined}
                    wrapperClassName={isFirstOne ? "cursor-pointer" : undefined}
                  />
                )
              })}
            </li>
          )
        })}
      </CollapsibleContent>
    </Collapsible>
  )
}

type TimelineGroupProps = {
  yearEntry: YearEntry
  isFirstGroup: boolean
}

const TimelineGroup = ({ yearEntry, isFirstGroup }: TimelineGroupProps) => {
  return (
    <>
      {!isFirstGroup && <p className="mt-4 border-b pb-4 text-xl font-bold">{yearEntry.year}</p>}
      <div className="space-y-4 divide-y">
        {yearEntry.content.map((dateGroup) => {
          return (
            <ul key={dateGroup.date} className="m-0! py-2">
              <CollapsibleWithIcon dateGroup={dateGroup} firstEntry={dateGroup.content[0]} />
            </ul>
          )
        })}
      </div>
    </>
  )
}

export { TimelineGroup }
